/**
 * There will be one reducer file per page / common component
 */
import {
    LIST_SHARE_USER,
    LIST_SHARE_USER_SUCCESS,
    LIST_SHARE_USER_FAILURE,
    SET_SELECTED_USER,
    SET_SELECTED_USER_INFO,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    userList: [],
    templateUID: '',
    userInfo: {},
    initialAlpstate: {},
    selectedUser: [],
    selectedUserInfo: {},
};

const ListShareUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIST_SHARE_USER:
            return {
                ...state,
                loading: true,
                userList: action.payload,
            };
        case LIST_SHARE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                userList: action.payload.userList,
                templateUID: action.payload.templateUID,
                userInfo: action.payload.userInfo,
                initialAlpstate: action.payload.initialAlpstate,
            };
        case LIST_SHARE_USER_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_SELECTED_USER:
            return {
                ...state,
                selectedUser: action.payload,
            };
        case SET_SELECTED_USER_INFO:
            return {
                ...state,
                selectedUserInfo: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default ListShareUserReducer;
